<div class="pos-relative dialogContainer">
  <button
    (click)="onCloseClick('')"
    class="closeBtn pull-right"
    mat-button
    color="accent"
    [attr.id]="buildControlId('dlg-btn-close')"
    >
    <span class="icon-ic-close popup_close"></span>
  </button>
  <p class="font-xl heading">Destination Path</p>
  <div class="p-b-s bottomBorderStyle overflow-x-auto">
    <div class="row-container">&lrm;
      @for (data of breadCrumbData; track data; let i = $index) {
        <span class="ml-5 d-inline-flex">
          @if (i !== 0) {
            <span class="mr-5">/</span>
          }
          @if (i===0 && data==='Pre-Archive') {
            <span>
              <span class="last-breadcrum-data">{{ data }}</span>&lrm;
            </span>
          }
          @if (i !== breadCrumbData.length - 1 ) {
            <a
              class="mr-5 breadCrumLabel"
              (click)="navigateFromBreadCrumb(i)"
              [attr.id]="buildControlId('dlg-btn-breadcrumb', i)"
              [matTooltip]="data" matTooltipClass="tooltip-style"
              >@if (!(i===0 && data ==='Pre-Archive')) {
              <span>{{ data }}</span>
              }</a
              >
            } @else {
              <span class="last-breadcrum-data">{{ data }}</span>&lrm;
            }
          </span>
        }
      </div>
    </div>
    <div class="destinationPathTableContainer">
      <table class="w-100" mat-table [dataSource]="bucketItems">
        <ng-container matColumnDef="ItemType">
          <td mat-cell *matCellDef="let item">
            <img
              class="icon-layout"
              [src]="
                item.Type === 'Folder'
                  ? 'assets/images/bucket-icons/icon-folder.svg'
                  : 'assets/images/bucket-icons/icon-file.svg'
              "
              alt="Folder"
              />
            </td>
          </ng-container>

          <ng-container matColumnDef="Name">
            <td mat-cell *matCellDef="let item; let rowIndex = index">
              @if (item.Type === 'Folder') {
                <span class="text-overflow-ellipsis">
                  <a (click)="navigateToFolder(item)" [attr.id]="buildControlId('dlg-lnk-folder', rowIndex)">{{ item.LeafName }}</a>
                </span>
              }
              @if (item.Type === 'File') {
                <span
                  class="text-overflow-ellipsis content-disabled"
                  >{{ item.LeafName }}</span
                  >
              }
            </td>
          </ng-container>
          <tr mat-row *matRowDef="let row; columns: columnList"></tr>
        </table>
      </div>
      <div class="actionButtonContainer">
        <button
          mat-raised-button
          color="primary"
          type="submit"
          class="mat-button-wrapper p-20 m-20 okbutton"
          (click)="onCloseClick('path')"
          [attr.id]="buildControlId('dlg-btn-select')"
          >
          Select Destination
        </button>
        <button
          mat-button
          (click)="onCloseClick('')"
          color="primary"
          class="mat-button p-20 m-20 cancelButton"
          [attr.id]="buildControlId('dlg-btn-cancel')"
          >
          Cancel
        </button>
      </div>
    </div>
